import { error } from "../../../Services/Error";
import { useDebounce } from "../../../Utils/utilities";
import { useState } from "react";
import FieldInput from "./FieldInput";
import http from "../../../Services/HTTP/HttpService";
import path from "../../../Services/path";
import translate from "../../../Utils/translate";

const FETCH_ERROR = "error";
const FETCH_RESULTS = "results";
const HIDE_RESULTS = "error";
const IS_FETCHING = "isFetching";

const FieldDomain = ({ formik, name, placeholder, required }) => {
  //'isFetching', 'results', 'error', 'hide'
  const [state, setState] = useState(HIDE_RESULTS);
  const [results, setResults] = useState();

  const debounce = useDebounce((query) => fetchCompanies(query), 500);

  const handleSearch = (event) => {
    setState(IS_FETCHING);

    debounce(event.target.value);

    formik && formik.handleChange(event);
  };

  const fetchCompanies = async (query) => {
    if (!query) return;

    try {
      const { result, response } = await http.GET(`${path.domain}/api/company?search=${query.replace(/ /g, "")}`);

      if (!response.ok) {
        return error("Error getting domains", result.error, response.status);
      }

      setResults(result.body);
      setState(FETCH_RESULTS);
    } catch (error) {
      setState(FETCH_ERROR);
    }
  };

  const handleClick = (event, company) => {
    event.stopPropagation();
    formik.setValues({
      ...formik.values,
      icon: company?.logo,
      domain: company?.domain,
      appName: company?.name,
    });
    setState(HIDE_RESULTS);
  };

  const getResults = () => {
    if (state !== FETCH_RESULTS || !results?.length) {
      return null;
    }

    return (
      <div className="absolute z-20 w-full max-h-46 drop-shadow-2xl mt-default border border-theme-text border-opacity-50 rounded-default bg-theme-secondary overflow-y-auto">
        {results?.map((company) => (
          <div
            className="flex align-middle items-center p-default cursor-pointer transition-all hover:bg-theme-primary-hover"
            key={company.domain}
            onMouseDown={(event) => handleClick(event, company)}
          >
            <img className="h-8 w-8 rounded-full mr-default" src={company.logo} alt={`Logo for ${company.domain}`} />
            <p className="text-md font-medium">{`${company.name} | ${company.domain}`}</p>
          </div>
        ))}
      </div>
    );
  };

  const getLoading = () => {
    if (state !== IS_FETCHING) {
      return null;
    }

    return (
      <div className="absolute z-20 w-full max-h-46 drop-shadow-2xl mt-default border border-theme-text border-opacity-50 rounded-default bg-theme-secondary overflow-y-auto">
        {[1, 2, 3].map((value) => (
          <div
            className="animate-pulse flex align-middle items-center p-default cursor-pointer transition-all hover:bg-theme-primary-hover"
            key={value}
          >
            <div className="w-[10%] mr-default">
              <div className="h-8 w-8 rounded-full bg-theme-primary"></div>
            </div>
            <div className="h-2 w-[80%] rounded-default bg-theme-primary"></div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="w-full relative" onBlur={() => setState(HIDE_RESULTS)}>
      <FieldInput
        errors={formik?.errors}
        name={name}
        onBlur={formik?.handleBlur}
        onChange={handleSearch}
        onFocus={(event) => results && setState(FETCH_RESULTS)}
        onMouseDown={(event) => setState(FETCH_RESULTS)}
        placeholder={placeholder}
        required={required}
        touched={formik?.touched}
        value={formik?.values?.domain}
      />

      {getLoading()}

      {getResults()}
    </div>
  );
};

FieldDomain.defaultProps = {
  name: "domain",
  placeholder: translate("forms.domain.placeholder"),
  required: true,
};

export default FieldDomain;
